{
  "import": "Импортировать пакет конфигураций",
  "create": "Создать пакет конфигураций",
  "form": {
    "name": "Имя пакета конфигураций",
    "version": "Версия",
    "description": "Описание пакета конфигураций",
    "monitoring_templates": "Шаблоны мониторинга",
    "monitoring_jobs": "Задания",
    "monitoring_hits": "Индикаторы здоровья",
    "monitoring_exporters": "Экспортеры",
    "enrichment_plans": "Планы обогащения",
    "dashboards": "Дашборды",
    "attributes": "Атрибуты",
    "ci_types": "Типы CI",
    "monitoring_vmagents": "Агенты сбора метрик",
    "monitoring_vmalerts": "Агенты обработки правил"
  }
}